import { FormFieldsEdit } from '../../../../types/form-types'
import { SetValue, ValidationErrors } from '../../../hooks/use-edit-form'
import { isCouncilUserOrAdmin } from '../../../services/user-utils'
import useUser from '../../../hooks/use-user'
import { TOOLTIP } from '../../../../constants/tooltips'
import { Card, CheckableField, CheckableFields, FormField, Heading, TextInput } from '@msaf/core-react'

interface WellDetailsOwnerCardEditProps {
  isLoading: boolean
  fields: Partial<FormFieldsEdit>
  setValue: SetValue<FormFieldsEdit>
  validationErrors: ValidationErrors
}

export default function WellDetailsOwnerCardEdit({
  isLoading,
  fields,
  setValue,
  validationErrors,
}: WellDetailsOwnerCardEditProps) {
  const { user } = useUser()
  return (
    <Card>
      <Heading isSkeleton={isLoading} level={4}>
        Owner
      </Heading>
      <FormField
        isSkeleton={isLoading}
        label='Type'
        htmlFor='ownerType'
        validationMessages={validationErrors?.ownerType}
      >
        <CheckableFields ariaLabelledBy='ownerType' isHorizontal>
          <CheckableField
            isSkeleton={isLoading}
            name='individualOwner'
            id='Individual'
            type='radio'
            label='Individual'
            checked={fields.ownerType === 'Individual'}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setValue('ownerType', e.target.id)}
          />
          <CheckableField
            isSkeleton={isLoading}
            name='companyOwner'
            id='Company'
            type='radio'
            label='Company'
            checked={fields.ownerType === 'Company'}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setValue('ownerType', e.target.id)}
          />
        </CheckableFields>
      </FormField>
      <FormField
        isSkeleton={isLoading}
        label='Owner name'
        htmlFor='ownerName'
        validationMessages={validationErrors?.ownerName}
      >
        <TextInput
          isInvalid={!!validationErrors['ownerName']}
          isSkeleton={isLoading}
          id='ownerName'
          value={`${fields.ownerName ?? ''}`}
          setValue={(value: string) => setValue('ownerName', value)}
        />
      </FormField>
      {isCouncilUserOrAdmin(user) && (
        <FormField
          toolTipMessage={TOOLTIP.customerReferenceNo}
          isSkeleton={isLoading}
          label='Customer reference number'
          htmlFor='customerReferenceNo'
          validationMessages={validationErrors?.customerReferenceNo}
        >
          <TextInput
            isInvalid={!!validationErrors['customerReferenceNo']}
            isSkeleton={isLoading}
            id='customerReferenceNo'
            value={`${fields.customerReferenceNo ?? ''}`}
            setValue={(value: string) => setValue('customerReferenceNo', value)}
          />
        </FormField>
      )}
    </Card>
  )
}
